import React, { useEffect, useState } from 'react';
import Menu from "../../components/Menu/Menu";
import { MenuProps } from "../../components/Menu/MenuTypes";
import { defaultMenuProps } from "../../constants/constants";
import FaqData from "../../components/Faq/FaqData/FaqData";
import { FaqDataProps } from "../../components/Faq/FaqData/FaqDataTypes";

const CrearFaq = (): React.ReactElement => {
  const [menuProps] = useState<MenuProps>(defaultMenuProps);
  const [faqData] = useState<FaqDataProps>({ faq: { _id: '' } });
  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <React.Fragment>
      <div id="menu">
        <Menu items={menuProps.items} />
      </div>
      <div id="app-content">
        <header className="table-header mb-4">
          <h1>Crear FAQ</h1>
          <span></span>
        </header>
        {loaded && <FaqData faq={faqData.faq} />}
      </div>
    </React.Fragment>
  );
};

export default CrearFaq;
